import React from 'react'
import PerspectiveHoverWrapper from '../components/PerspectiveHoverWrapper';
import ReactPlayer from 'react-player';
import Button from '../components/Button';
import Spline from '@splinetool/react-spline';
import ServicesShowcase from '../components/ServicesShowcase';
import { useServiceData } from '../context/ServiceDataContext';
import { Link, useLocation } from 'react-router-dom';



// Modular Icon Component - replace src with your icon URL
const SpeedIcon = ({ src, alt = "Speed icon" }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className="w-16 h-16 mb-8 mx-auto xl:mx-0"
      />
    );
  }

  // Fallback SVG icon similar to your design
  return (
    <div className="w-16 h-16 mb-8 text-[#EE005B]">
      <svg viewBox="0 0 64 64" fill="currentColor" className="w-full h-full">
        <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" fill="none" />
        <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="2" fill="none" />
        <path d="M32 12 L36 16 L32 20 L28 16 Z" fill="currentColor" />
        <path d="M20 24 L24 28 L20 32 L16 28 Z" fill="currentColor" />
        <path d="M44 24 L48 28 L44 32 L40 28 Z" fill="currentColor" />
        <path d="M20 40 L24 44 L20 48 L16 44 Z" fill="currentColor" />
        <path d="M44 40 L48 44 L44 48 L40 44 Z" fill="currentColor" />
        <path d="M32 52 L36 56 L32 60 L28 56 Z" fill="currentColor" />
      </svg>
    </div>
  );
};

// Modular Check Icon Component
const CheckIcon = () => (
  <svg className="w-5 h-5 text-[#EE005B] mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
  </svg>
);

// Modular Feature Item Component
const FeatureItem = ({ children }) => (
  <div className="flex items-start mb-4">
    <CheckIcon />
    <span className="dark:text-gray-300 text-zinc-500 text-lg leading-relaxed">
      {children}
    </span>
  </div>
);

// Main Component
const FastExperienceUI = ({ data }) => {
  return (
    <div className=" p-4 px-8 flex items-center justify-center dark:hover:bg-zinc-950 hover:bg-zinc-100 pointer-events-auto duration-300 rounded">
      <div className="xl:max-w-md w-full">
        {/* Icon Section */}
        <SpeedIcon src={data.iconSrc} />

        {/* Main Heading */}
        <h1 className="dark:text-white w-full text-xl font-bold mb-8 leading-tight text-center xl:text-left">
          {data.p}
        </h1>

        {/* Features List */}
        <div className="space-y-1">
          {
            data.features.map((feature, index) => (
              <FeatureItem key={index}>
                {feature}
              </FeatureItem>
            ))
          }
        </div>
      </div>
    </div>
  );
};





const cardData = [
  {
    iconSrc: "/new-final-data/branding-page/1.svg",
    p: `From Attention to Action. Great branding isn’t about being seen, it’s about being chosen.
`,
    features: [
      "Maximise Conversion",
      "Turn interest into impact",
      "Make first impressions unforgettable"
    ]
  },
  {
    iconSrc: "/new-final-data/branding-page/2.svg",
    p: `A Voice That Carries Your brand’s message deserves clarity, not clutter. We create a language, visual and verbal that speaks consistently across platforms.`,
    features: [
      "Optimise Communication",
      "Strengthen your story",
      "Create clarity across touchpoints"
    ]
  },
  {
    iconSrc: "/new-final-data/branding-page/3.svg",
    p: `Where Trust Becomes Devotion.The strongest brands don’t chase the customers; they earn believers.`,
    features: [
      "Increase Loyalty",
      "Inspire repeat engagement",
      "Build emotional connections"
    ]
  },
]

// Services Showcase Data
const servicesData = {
  topHeading: "What Do We Serve ?",
  mainHeading: "We help you translate\na simple idea into an exotic\nDigital design transformation vision.",
  p: "",
  services: [
    [
      "UI Design",
      "UI Development",
      "UI Guidelines",
      "Design System"
    ],
    [
      "UX Design",
      "User Research",
      "UX Consultancy",
      "UX Writing"
    ],
    [
      "Animations",
      "Iconography",
      "Illustrations"
    ]
  ]
};



const BrandingSection1 = () => {

  const { getServiceById, getServiceByCategory } = useServiceData();
  // const designServices = getServiceByCategory(`${pathname.split("/")[1]}`);
  const designServices = getServiceByCategory(`design`);

  // const {pathname} = useLocation();

  // console.log(designServices);

  return (
    <div className=''>
      {/* <h3 className='text-sm text-zinc-500 font-semibold uppercase text-center'>Create your Dream Brand</h3>
      <h1 className="text-5xl font-bold mt-2 tracking-tighter text-center">
        At Digicots we like things... <br />
        <span className='flex items-center gap-5 text-center justify-center'>
          different.
        </span>
      </h1> */}

      <div className='flex min-h-screen flex-col-reverse xl:flex-row items-center text-white bg-black justify-between gap-10 xl:px-35 pointer-events-auto'>
        <div className='h-fit xl:w-[60vw] w-[100vw] px-10 space-y-5  xl:ml-10 py-20'>
          <div className="">
            <h3 className='text-sm text-zinc-500 font-semibold uppercase text-center xl:text-left '>TURN DIFFERENCE INTO DOMINANCE</h3>
            <h1 className="xl:text-6xl text-4xl font-bold mt-2 text-center xl:text-left  ">
              Design Flows, Creativity Beats
            </h1>
          </div>
          <div className="">
            <p className="xl:text-lg  dark:text-zinc-200 text-center xl:text-left ">At Digicots, we study human behavior, integrate data science and information architecture, and craft a unique blended experience that enhances user interaction.
            </p>
          </div>

          <Link to={"/contact"} className='w-full mx-auto flex xl:inline justify-center items-center'>
            <Button style={{ border: "1px solid rgba(255, 255, 255, 0.5) !important" }}>Contact us</Button>
          </Link>

        </div>
        <div className="xl:w-fit w-full">
          <div className="h-screen w-[600px] relative hidden xl:block">
            <Spline
              className='scale-100'
              scene="https://prod.spline.design/C5THQp1fLhuxhSfk/scene.splinecode"
            />
            <div className="absolute bottom-[2.5%] right-[2.5%] h-[40px] w-[150px] bg-black"></div>

          </div>
          <div className="h-screen w-full relative xl:hidden">
            <img src="/new-final-data/branding-page/branding-landing.png" className='h-full w-full object-cover' alt="" />
          </div>

        </div>
      </div>




      <div className=' xl:px-35 px-10 grid md:grid-cols-2 xl:grid-cols-3 py-20 gap-x-5 '>

        {cardData.map((data, i) => (<>
          <PerspectiveHoverWrapper key={i}>
            <FastExperienceUI data={data} />
          </PerspectiveHoverWrapper>
        </>))}
      </div>


      <div className='h-fit w-full'>

        <div
          className='hidden xl:block'
        >
          <ReactPlayer src={"/videos/Clip2.webm"}
            autoPlay={true}
            loop={true}
            muted={true}
            controls={false}
            height={"100%"}
            width={"100%"}
          />
        </div>
        <div
          className='xl:hidden'
        >
          <ReactPlayer src={"/videos/Clip2.webm"}
            controls={true}
            height={"100%"}
            width={"100%"}
          />
        </div>
      </div>

    </div>
  )
}

export default BrandingSection1